class GuestPageController {

    constructor($window, basket, guestApi, messageService, loginoutService) {
        this.$window = $window;
        this.basket = basket;
        this.guestApi = guestApi;
        this.messageService = messageService;
        this.loginoutService = loginoutService;
    }

    basketUrl () {
        let status = this.basket.contents.basket_status;
        if (this.basket.contents.basket_status === 'checkout') {
            status = this.basket.contents.first_step;
        }
        return `/checkout/${status}`;
    }

    validate () {
        if (this.saving) {
            return false;
        }

        for (const guest of this.basket.contents.guest_details) {
            if (!guest.last_name || !guest.first_name || !guest.title) {
                this.messageService.add('Please check the fields for errors and try saving again.');
                this.messageService.failure();
                return false;
            }
        }

        return true;
    }

    saveGuests () {
        this.saving = true;
        return this.guestApi.save(this.basket.contents.identity_code, this.basket.contents.guest_details)
            .then(() => {
                this.messageService.add('Guests updated successfully.');
                this.messageService.success();
            })
            .catch((error) => {
                this.saving = false;
                this.messageService.add('Sorry, there was an error updating your details. Please try again or contact us if the problem persists.');
                this.messageService.failure();

                throw error;
            });
    }

    goToHome () {
        if (!this.validate()) {
            return;
        }

        return this.saveGuests()
            .then(() => {
                this.$window.location = '/';
            })
            .catch(() => { });
    }

    goToCheckout () {
        if (!this.validate()) {
            return;
        }

        return this.saveGuests()
            .then(() => {
                this.$window.location = this.basketUrl();
            })
            .catch(() => { });
    }

    isDisabled (guest) {
        if (this.saving) {
            return true;
        }

        if (this.basket.contents.client_id && guest.integration_reference) {
            return this.basket.contents.client_id === guest.integration_reference;
        }

        return false;
    }

    titleIsAvailable (guest) {
        if (this.basket.contents.client_id
            && guest.integration_reference
            && (this.basket.contents.client_id === guest.integration_reference)) {
            return false;
        }

        return true;
    }

    showForm () {
        return !this.loginoutService.isEditing();
    }
}

GuestPageController.$inject = ['$window', 'basket', 'guestApi', 'messageService', 'loginoutService'];

export default GuestPageController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/controllers/guest.edit.controller.js